import { motion } from 'motion/react';
import Navbar from '@/components/feature/Navbar';

const repairServices = [
  {
    id: 1,
    title: 'Screen Replacement',
    description:
      'Cracked or broken display? We replace screens for iPhone, Samsung, OnePlus, Vivo, OPPO, Xiaomi & more using genuine-quality parts. Most screen replacements are completed within 30–60 minutes with proper calibration and testing.',
    features: ['Genuine-quality displays', '30–60 min turnaround', '6-month warranty', 'All major brands'],
    image:
      'https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20replacement%20repair%20in%20professional%20workshop%2C%20technician%20hands%20carefully%20replacing%20cracked%20smartphone%20glass%20display%20on%20clean%20workbench%20with%20precision%20tools%20and%20spare%20parts%2C%20warm%20ambient%20workshop%20lighting%2C%20photorealistic%20detailed%20close-up%2C%20warm%20neutral%20tones&width=800&height=600&seq=repair-screen-01&orientation=landscape',
    icon: 'ri-smartphone-line',
  },
  {
    id: 2,
    title: 'Battery Replacement',
    description:
      'Phone not holding charge? We swap out degraded batteries with high-capacity genuine replacements. Includes battery health calibration and performance testing to ensure your phone lasts all day again.',
    features: ['OEM-grade batteries', 'Same-day service', 'Calibration included', 'Safe disposal of old battery'],
    image:
      'https://readdy.ai/api/search-image?query=Mobile%20phone%20battery%20replacement%20repair%20in%20professional%20electronics%20service%20center%2C%20technician%20carefully%20removing%20and%20installing%20new%20lithium%20battery%20into%20smartphone%20with%20precision%20tools%20on%20clean%20anti-static%20workbench%2C%20warm%20workshop%20lighting%2C%20photorealistic%20detailed%20close-up%2C%20warm%20neutral%20tones&width=800&height=600&seq=repair-battery-01&orientation=landscape',
    icon: 'ri-battery-charge-line',
  },
  {
    id: 3,
    title: 'Motherboard & IC Repair',
    description:
      'Dead phone, no power, or random restarts? Our experienced technicians diagnose and repair motherboard issues including IC replacement, soldering, and micro-level circuit repairs. We bring phones back to life that others have given up on.',
    features: ['Micro-soldering expertise', 'IC-level repair', 'Water damage recovery', 'Diagnostic included'],
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20motherboard%20circuit%20board%20repair%20under%20microscope%20in%20professional%20electronics%20service%20center%2C%20technician%20using%20hot%20air%20rework%20station%20and%20precision%20soldering%20iron%20on%20tiny%20IC%20chips%2C%20magnifying%20lens%20view%2C%20warm%20workshop%20lighting%2C%20photorealistic%20detailed%20close-up%2C%20warm%20neutral%20tones&width=800&height=600&seq=repair-motherboard-01&orientation=landscape',
    icon: 'ri-cpu-line',
  },
  {
    id: 4,
    title: 'Charging Port Repair',
    description:
      'Phone not charging properly or loose cable connection? We repair and replace charging ports for all models. Includes cleaning, port replacement, and thorough testing to ensure stable charging and data transfer.',
    features: ['USB-C & micro-USB ports', 'Loose connection fix', 'Data transfer verified', 'Quick turnaround'],
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20charging%20port%20micro-USB%20USB-C%20connector%20replacement%20repair%20close-up%2C%20technician%20soldering%20charging%20port%20on%20mobile%20phone%20PCB%20board%20with%20precision%20tools%20on%20clean%20anti-static%20workbench%2C%20warm%20workshop%20lighting%2C%20photorealistic%20detailed%20macro%20shot%2C%20warm%20neutral%20tones&width=800&height=600&seq=repair-charging-01&orientation=landscape',
    icon: 'ri-plug-line',
  },
  {
    id: 5,
    title: 'Software & Unlocking',
    description:
      'Forgot password? Phone stuck in boot loop? Need FRP unlock? We handle software flashing, OS recovery, password removal, and bootloader unlocking for all major brands. Your data safety is our priority.',
    features: ['FRP unlock', 'Password removal', 'OS flashing', 'Data recovery'],
    image:
      'https://readdy.ai/api/search-image?query=Smartphone%20software%20repair%20and%20flashing%20process%20on%20computer%20screen%20connected%20to%20mobile%20phone%20in%20professional%20service%20center%2C%20technician%20using%20diagnostic%20software%20interface%20showing%20progress%20bars%20and%20device%20info%2C%20clean%20modern%20workspace%2C%20warm%20neutral%20lighting%2C%20photorealistic%20detailed%20shot&width=800&height=600&seq=repair-software-01&orientation=landscape',
    icon: 'ri-lock-unlock-line',
  },
  {
    id: 6,
    title: 'Water Damage Recovery',
    description:
      'Dropped your phone in water? Bring it to us immediately. We perform ultrasonic cleaning, component-level drying, and thorough diagnostics to recover as much functionality as possible. The sooner you bring it, the better the chances.',
    features: ['Ultrasonic cleaning', 'Component-level drying', 'Corrosion treatment', 'Diagnosis first'],
    image:
      'https://readdy.ai/api/search-image?query=Water%20damaged%20smartphone%20repair%20process%20in%20professional%20electronics%20service%20center%2C%20technician%20carefully%20disassembling%20wet%20phone%20and%20cleaning%20internal%20components%20with%20isopropyl%20alcohol%20on%20anti-static%20mat%2C%20precision%20tools%20and%20drying%20equipment%20visible%2C%20warm%20workshop%20lighting%2C%20photorealistic%20detailed%20shot%2C%20warm%20neutral%20tones&width=800&height=600&seq=repair-water-01&orientation=landscape',
    icon: 'ri-drop-line',
  },
  {
    id: 7,
    title: 'Home Appliance Repair',
    description:
      'Refrigerator not cooling? Washing machine making noise? Mixer grinder not working? We repair home & kitchen appliances from all major brands including LG, Samsung, Whirlpool, Godrej, Panasonic & Haier. Genuine spare parts used.',
    features: ['Refrigerators', 'Washing machines', 'Mixers & grinders', 'Genuine spare parts'],
    image:
      'https://readdy.ai/api/search-image?query=Home%20appliance%20repair%20service%20technician%20working%20on%20refrigerator%20in%20customer%20home%20or%20workshop%2C%20professional%20technician%20with%20tool%20kit%20diagnosing%20and%20repairing%20stainless%20steel%20fridge%20with%20screwdriver%20and%20multimeter%2C%20warm%20natural%20lighting%2C%20photorealistic%20detailed%20shot%2C%20warm%20neutral%20tones&width=800&height=600&seq=repair-appliance-01&orientation=landscape',
    icon: 'ri-home-gear-line',
  },
];

const processSteps = [
  {
    step: '01',
    title: 'Diagnosis',
    description: 'Bring your device. We inspect and identify the exact issue within minutes.',
    icon: 'ri-search-line',
  },
  {
    step: '02',
    title: 'Quote',
    description: 'Get a clear, honest price estimate. No hidden charges — ever.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '03',
    title: 'Repair',
    description: 'Our technicians fix it using quality parts and proper tools.',
    icon: 'ri-tools-line',
  },
  {
    step: '04',
    title: 'Testing',
    description: 'We thoroughly test every function before handing it back.',
    icon: 'ri-shield-check-line',
  },
  {
    step: '05',
    title: 'Warranty',
    description: 'Walk out with a warranty card. Peace of mind included.',
    icon: 'ri-award-line',
  },
];

export default function ServicesRepairsPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20mobile%20phone%20repair%20workshop%20interior%20wide%20shot%2C%20technician%20repairing%20smartphone%20on%20illuminated%20workbench%20with%20precision%20tools%2C%20spare%20parts%20and%20diagnostic%20equipment%20organized%20on%20shelves%2C%20warm%20ambient%20lighting%20with%20focused%20task%20lamps%2C%20clean%20modern%20service%20center%20atmosphere%2C%20photorealistic%20detailed%20photography%2C%20warm%20neutral%20tones&width=1600&height=900&seq=repairs-hero-01&orientation=landscape"
            alt="Professional Repair Workshop"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            <span className="inline-block bg-accent-500/20 text-accent-300 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
              Expert Technicians · Genuine Parts
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4">
              Services & Repairs
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8">
              From screen replacements to motherboard repairs — we fix mobiles, appliances, and electronics with skill, speed, and honesty. All work comes with a warranty.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/book-service"
                className="bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-sm"></i>
                </span>
                Book a Service
              </a>
              <a
                href="tel:+919964111963"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-sm"></i>
                </span>
                Call +91 99641 11963
              </a>
              <a
                href="#repair-services"
                className="border-2 border-background-300/60 hover:border-background-50 text-background-100 hover:text-background-50 px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-sm"></i>
                </span>
                View Services
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Repair Services */}
      <section id="repair-services" className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="text-center mb-12 md:mb-16"
          >
            <span className="inline-block bg-primary-100 text-primary-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
              What We Fix
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              Repair Services
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              Professional repair for smartphones, appliances, and electronics. We use quality parts and back every repair with a warranty.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 gap-6 md:gap-8 max-w-5xl mx-auto">
            {repairServices.map((service, index) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: (index % 2) * 0.1, ease: 'easeOut' }}
                className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 shadow-sm hover:shadow-lg"
              >
                <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] lg:grid-cols-[380px_1fr]">
                  <div className="relative aspect-[4/3] md:aspect-auto overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute top-3 left-3 w-10 h-10 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-xl">
                      <i className={`${service.icon} text-lg`}></i>
                    </div>
                  </div>
                  <div className="p-5 md:p-6 lg:p-8 flex flex-col justify-center">
                    <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-semibold text-foreground-950 mb-3">
                      {service.title}
                    </h3>
                    <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                      {service.description}
                    </p>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-5">
                      {service.features.map((feature) => (
                        <li key={feature} className="flex items-center gap-2 text-sm text-foreground-700">
                          <span className="w-4 h-4 flex items-center justify-center shrink-0">
                            <i className="ri-check-line text-accent-500 text-sm"></i>
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <div className="flex flex-col sm:flex-row gap-3 mt-auto">
                      <a
                        href="/book-service"
                        className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 px-5 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-calendar-check-line text-xs"></i>
                        </span>
                        Book Service
                      </a>
                      <a
                        href="tel:+919964111963"
                        className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-phone-line text-xs"></i>
                        </span>
                        Get a Quote
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Repair Process */}
      <section className="py-16 md:py-24 bg-background-100">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="text-center mb-12 md:mb-16"
          >
            <span className="inline-block bg-accent-100 text-accent-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
              How It Works
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              Our Repair Process
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              Simple, transparent, and fast. From diagnosis to warranty — we keep you informed every step.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6 max-w-6xl mx-auto">
            {processSteps.map((step, index) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: index * 0.1, ease: 'easeOut' }}
                whileHover={{ y: -6 }}
                className="relative bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 text-center group"
              >
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 group-hover:bg-primary-500 rounded-full transition-colors duration-300">
                  <i className={`${step.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <span className="inline-block text-primary-500 font-bold text-xs mb-2">
                  Step {step.step}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                  {step.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Warranty Banner */}
      <section className="py-14 md:py-20 bg-primary-500">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-background-50/20 rounded-full">
              <i className="ri-shield-check-line text-3xl text-background-50"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
              Every Repair Backed by Warranty
            </h2>
            <p className="text-primary-100 text-sm md:text-base max-w-xl mx-auto mb-6">
              We stand behind our work. Screen replacements get 6 months, battery swaps get 3 months, and motherboard repairs get 1 month of warranty. If something goes wrong, we make it right — no questions asked.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              <span className="inline-flex items-center gap-2 bg-background-50/15 text-background-50 px-4 py-2 rounded-full text-sm font-medium">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-xs"></i>
                </span>
                Screen: 6 Months
              </span>
              <span className="inline-flex items-center gap-2 bg-background-50/15 text-background-50 px-4 py-2 rounded-full text-sm font-medium">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-xs"></i>
                </span>
                Battery: 3 Months
              </span>
              <span className="inline-flex items-center gap-2 bg-background-50/15 text-background-50 px-4 py-2 rounded-full text-sm font-medium">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-xs"></i>
                </span>
                Motherboard: 1 Month
              </span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
              Need a Repair? We're Here.
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto mb-8">
              Walk into our shop in Tumkur or call us. We'll diagnose your device, give you a fair quote, and get it fixed — fast.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
              <a
                href="/book-service"
                className="bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-sm"></i>
                </span>
                Book a Service Online
              </a>
              <a
                href="tel:+919964111963"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-sm"></i>
                </span>
                Call +91 99641 11963
              </a>
              <a
                href="https://wa.me/+919964111963"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-sm"></i>
                </span>
                WhatsApp Us
              </a>
              <a
                href="/"
                className="border-2 border-background-200/70 hover:border-primary-300 text-foreground-700 hover:text-primary-600 px-8 py-3.5 rounded-full font-semibold text-base transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 hover:scale-105 active:scale-95"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line text-sm"></i>
                </span>
                Back to Home
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}